import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

const AlternativeStock = (props) => {
    if (props) {
        return (<></>);
    }
    return (
        <div key={'alternativeStock_'+props.sku} className="alternative-product-stock">
            <span className="alternative-product-stock__label">
                <Translation
                    tagName="p"
                    translationKey="product-tile-alternative-stock-availability"
                    placeholder={{stock: props.stock, price: props.price}}
                />
            </span>
        </div>);
};


AlternativeStock.propTypes = {
    stock: PropTypes.number.isRequired,
    sku: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    productBatchStocks: PropTypes.object,
    onAlternativeProductStockClick: PropTypes.func.isRequired,
};

export default AlternativeStock;
